import { parsePhoneNumberFromString } from 'libphonenumber-js';

/**
 * Formatuje numer w E.164 (np. "+48512345678") do postaci międzynarodowej
 * z separatorami ("+48 512 345 678"). Jeśli nie da się sparsować —
 * zwraca wejście bez zmian.
 */
export function formatPhone(e164: string): string {
  const parsed = parsePhoneNumberFromString(e164);
  if (!parsed) return e164;
  return parsed.formatInternational();
}
